import { render, staticRenderFns } from "./wareDetail.vue?vue&type=template&id=5fccf82a&scoped=true"
import script from "./wareDetail.vue?vue&type=script&lang=js"
export * from "./wareDetail.vue?vue&type=script&lang=js"
import style0 from "./wareDetail.vue?vue&type=style&index=0&id=5fccf82a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fccf82a",
  null
  
)

export default component.exports